import { defineMessages } from 'react-intl';

export default defineMessages({
    noLiabilityCoverages: {
        id: 'portal.views.policy-liability-component.No Liability Coverages available',
        defaultMessage: 'No Liability Coverages available'
    },
    name: {
        id: 'portal.views.policy-liability-component.Name',
        defaultMessage: 'Name'
    },
    amount: {
        id: 'portal.views.policy-liability-component.Amount',
        defaultMessage: 'Amount'
    },
    effDate: {
        id: 'portal.views.policy-liability-component.Eff Date',
        defaultMessage: 'Eff Date'
    },
    expDate: {
        id: 'portal.views.policy-liability-component.Exp Date',
        defaultMessage: 'Exp Date'
    },
    proration: {
        id: 'portal.views.policy-liability-component.Proration',
        defaultMessage: 'Proration'
    },
    premium: {
        id: 'portal.views.policy-liability-component.Premium ($)',
        defaultMessage: 'Premium ($)'
    },
    extensionLimit: {
        id: 'portal.views.policy-liability-component.Extension Limit',
        defaultMessage: 'Extension Limit'
    }
});
